import React from 'react'

export default function Footer () {
  return <p className='text-muted footer'>
    &copy; {new Date().getFullYear()} Mutual of Omaha Insurance Company. All rights reserved.
  </p>
}